import { motion } from "framer-motion";
import { SERVICE_CATEGORIES } from "../data/services";

export const ServiceTabs = ({ activeId, onSelect }) => (
  <nav
    data-testid="services-category-nav"
    aria-label="Service categories"
    className="-mx-5 flex gap-2 overflow-x-auto px-5 pb-3 sm:-mx-8 sm:px-8 lg:mx-0 lg:flex-col lg:gap-1 lg:overflow-visible lg:px-0 lg:pb-0"
  >
    {SERVICE_CATEGORIES.map(({ id, name, icon: Icon, items }, index) => {
      const active = id === activeId;
      return (
        <button
          key={id}
          type="button"
          onClick={() => onSelect(id)}
          data-testid={`services-index-${id}`}
          aria-selected={active}
          role="tab"
          className={`group relative flex shrink-0 items-center gap-3 rounded-full border px-4 py-2.5 text-left transition-[border-color,background-color,color] duration-300 lg:w-full lg:rounded-none lg:border-0 lg:border-l lg:py-4 lg:pl-6 lg:pr-3 ${
            active
              ? "border-[#C9A24B] bg-[#C9A24B]/10 text-[#F2EFE6] lg:bg-transparent"
              : "border-[rgba(201,162,75,0.25)] text-[#F2EFE6]/60 hover:border-[#C9A24B]/60 hover:text-[#F2EFE6] lg:border-[rgba(242,239,230,0.12)]"
          }`}
        >
          {active && (
            <motion.span
              layoutId="service-tab-marker"
              className="absolute -left-px top-0 hidden h-full w-px bg-[#C9A24B] lg:block"
              transition={{ type: "spring", stiffness: 380, damping: 34 }}
            />
          )}
          <span className="hidden font-brand text-lg leading-none text-[#C9A24B]/60 lg:block">
            {String(index + 1).padStart(2, "0")}
          </span>
          <Icon className={`h-4 w-4 shrink-0 ${active ? "text-[#C9A24B]" : "text-[#C9A24B]/60"}`} />
          <span className="whitespace-nowrap font-body text-xs font-medium uppercase tracking-[0.15em] lg:whitespace-normal lg:text-[13px] lg:leading-snug">
            {name}
          </span>
          <span className="ml-auto hidden font-body text-[11px] tracking-widest text-[#F2EFE6]/40 lg:block">
            {items.length}
          </span>
        </button>
      );
    })}
  </nav>
);
